import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import idmAuth from './modules/idmAuth'
import appRes from './modules/applicationResources'
import currentTarget from '@/appLogic/targets/currentTarget/store'
import createTarget from '@/appLogic/targets/createTarget/store'
import notifications from '@/appLogic/notifications/store'
import route from '@/appLogic/route/store'
import permissions from '@/appLogic/permissions/store'
import workbench from '@/appLogic/workbench/common/store'
import routerStore from '@/router/store'
import networks from '@/appLogic/networks/store/index'
import audienceHub from '@/views/audienceHub/store'

import * as authConstants from './modules/auth/constants'
import * as appResourceConstants from './modules/applicationResources/constants'

export {
  authConstants,
  appResourceConstants
}

Vue.use(Vuex)

// Separate Module States refer to - http://vuex.vuejs.org/en/modules.html
// example - import placeHolder from './modules/placeHolder/store'

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    auth,
    idmAuth,
    appRes,
    currentTarget,
    notifications,
    createTarget,
    route,
    permissions,
    workbench,
    routerStore,
    networks,
    audienceHub,
  }
})

export default store

let modulesToDelete = null

/**
 * Creates a wrapper component that handles registering and de-registering a module from the store when
 * it is created and destroyed
 * @param path {string} The desired modules path
 * @param module {Object} The module definition including its state, getters, actions and mutations
 * @param callbacks {Object} Optional onRegistered and onUnregistered callbacks
 * @returns {function(*=)} A function that accepts the Component to connect to the store
 */
export function createStoreConnector (path, modules, {onRegistered = () => {}, onUnregistered = () => {}}) {
  // modules = Array.isArray(modules) ? modules : [modules]
  // console.log(modules)
  return (Component) => {
    let newMixins = []
    newMixins = newMixins.concat([{
      created () {
        if (modulesToDelete) {
          store.unregisterModule(modulesToDelete.path)
          onUnregistered(store, modulesToDelete.modules)
        }
        modulesToDelete = {modules, path}
        store.registerModule(path, modules)
        onRegistered(store, modules)
      }
    }])
    Component.mixins = Component.mixins || []
    newMixins = newMixins.concat(Component.mixins)
    Component.mixins = newMixins
    return Component
  }
}

class RegisterModIfNotExistClass {
  constructor (modulePath, mods) {
    this.modulePath = modulePath
    this.currentMod = mods
    this.currentPath = 0
  }

  doesItExist () {
    let currentModName = this.modulePath[this.currentPath]
    this.currentPath = this.currentPath + 1
    this.currentMod = this.currentMod[currentModName]
    if (this.modulePath.length === this.currentPath) {
      if (!this.currentMod) {
        return false
      } else {
        return true
      }
    } else {
      this.currentMod = this.currentMod._children
      return this.doesItExist()
    }
  }
}

const isFunction = function (functionToCheck) {
  return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]'
}

export const registerIfNotExist = function (modulePath, moduleToRegister) {
  let mods = store._modules.root._children
  let exists = new RegisterModIfNotExistClass(modulePath, mods).doesItExist()
  if (!exists) {
    if (isFunction(moduleToRegister)) {
      store.registerModule(modulePath, moduleToRegister())
    } else {
      store.registerModule(modulePath, moduleToRegister)
    }
  }
}

export const unregisterIfExists = function (modulePath) {
  let mods = store._modules.root._children
  let exists = new RegisterModIfNotExistClass(modulePath, mods).doesItExist()
  if (exists) {
    store.unregisterModule(modulePath)
  }
}

export function setState (state, record) {
  for (let key of Object.keys(record)) {
    state[key] = record[key]
  }
}



// WEBPACK FOOTER //
// ./src/app/store/index.js